"use client";
import React from "react";
import { cn, tinaField, useTina } from "@/lib/utils";

import Section from "@/components/ui/Section";
import Image from "next/image";
import Markdown from "@/components/Markdown";

import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";

dayjs.extend(advancedFormat);

export function getArticleImage(imageTemplate) {
  switch (imageTemplate) {
    case "template-1":
      return {
        imageUrl:
          "https://res.cloudinary.com/dhr0wjkar/image/upload/v1743843895/Emerald_Power_Frame_3_btv0ny.png",
        className: "text-white",
      };
    case "template-2":
      return {
        imageUrl:
          "https://res.cloudinary.com/dhr0wjkar/image/upload/v1743843899/Metric_Item_from_Emerald_Power_3_ofiqjc.png",
        className: "text-white",
      };
    case "template-3":
      return {
        imageUrl:
          "https://res.cloudinary.com/dhr0wjkar/image/upload/v1743843907/Metric_Item_from_Emerald_Power_2_ev2gbq.png",
        className: "text-primary",
      };
    case "template-4":
      return {
        imageUrl:
          "https://res.cloudinary.com/dhr0wjkar/image/upload/v1743843903/Emerald_Power_Frame_2_ldah3h.png",
        className: "text-primary",
      };
  }
}

export default function ArticlePage({ lang, ...props }) {
  const { data } = useTina({
    query: props.query,
    variables: props.variables,
    data: props.data,
  });

  const isPublished = data?.article?.published;

  const translatedArticle =
    data?.article?.translations.find((translation) => translation.locale === lang) ||
    data?.article?.translations.find((translation) => translation.locale === "en");

  const articleImage = getArticleImage(data?.article?.imageTemplate);

  return (
    <div>
      <Section
        wrapperClassName="py-12 pb-24 px-4 md:px-8"
        className="relative content-sm bg-white rounded-3xl !px-0 overflow-hidden"
      >
        <div className="relative">
          <Image
            src={articleImage?.imageUrl}
            className={cn(
              "aspect-[2] object-cover object-right-bottom w-full min-h-[200px]",
              isPublished ? "opacity-100" : "opacity-60"
            )}
            alt={translatedArticle?.title}
            width={896}
            height={448}
            quality={100}
          />
          <div className="absolute top-0 left-0 w-full h-full py-8 px-8 lg:px-12">
            <h1
              data-tina-field={tinaField(translatedArticle, "title")}
              className={cn(
                "max-sm:!text-2xl h2 !leading-[150%] line-clamp-3",
                articleImage?.className
              )}
            >
              {translatedArticle?.title}
            </h1>
          </div>
          {!isPublished && (
            <div className="absolute inset-0 flex items-center justify-center z-10">
              <div className="text-7xl font-bold text-primary -rotate-45 translate-y-8">DRAFT</div>
            </div>
          )}
        </div>
        <div className="mx-auto content-xs py-8 lg:py-12">
          <div className="text-base text-gray-500 mb-1">
            {dayjs(data?.article?.date).format("Do MMMM YYYY")}
          </div>
          <h2 className="p-xl !font-medium !mt-0 mb-6 pb-6 border-b border-grey-200 !leading-[150%]">
            {translatedArticle?.summary}
          </h2>
          <div data-tina-field={tinaField(translatedArticle, "body")}>
            <Markdown content={translatedArticle?.body} />
          </div>
        </div>
      </Section>
    </div>
  );
}
